import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { Box, Typography } from "@mui/material";
import { MenuItemPreviewSearchFragment } from "apps/web/src/types";
import WarningIcon from "apps/web/src/components/universal/WarningIcon";

interface MenuItemsPanelDragOverlayProps {
  menuItem: MenuItemPreviewSearchFragment;
}

/** Drag ghost matching Figma Drag/Drop — elevated panel row under the pointer. */
export const MenuItemsPanelDragOverlay = ({ menuItem }: MenuItemsPanelDragOverlayProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        bgcolor: "common.white",
        border: theme => `1px solid ${theme.palette.greyscale[300]}`,
        borderRadius: "6px",
        px: 1,
        py: 1,
        width: 280,
        boxShadow: 6,
        cursor: "grabbing",
      }}
    >
      <DragIndicatorIcon
        sx={{
          fontSize: 16,
          color: "greyscale.500",
          flexShrink: 0,
        }}
        aria-hidden
      />
      <Box sx={{ display: "flex", alignItems: "center", minWidth: 0, flex: 1 }}>
        {menuItem.isMissingIngredients && (
          <WarningIcon sx={{ fontSize: "16px", mr: 0.5, flexShrink: 0 }} tip="Missing Ingredients" />
        )}
        <Typography
          variant="subtitle1"
          noWrap
          sx={{ fontWeight: 500, lineHeight: "20px", minWidth: 0 }}
        >
          {menuItem.name}
        </Typography>
      </Box>
    </Box>
  );
};
